export default [
  {
    path: '/record/attendance',
    name: 'attendance',
    component: () => import('@views/record/attendance/index.vue'),
    meta: {
      title: '考勤表'
    }
  },
  {
    path: '/record/train',
    name: 'train',
    component: () => import('@views/record/train/index.vue'),
    meta: {
      title: '视频教程'
    }
  },
]
